// Icons
import ArrowRightIcon from "@/assets/icons/dashboard/arrow_right_circle.svg";
import FinishedStatusIcon from "@/assets/icons/dashboard/check_circle_blue.svg";
import PendingStatusIcon from "@/assets/icons/dashboard/check_circle_grey.svg";
import CloseIcon from "@/assets/icons/dashboard/x_close.svg";
import TrashIcon from "@/assets/icons/dashboard/trash.svg";
import Chronometer from "@/assets/icons/dashboard/chronometer.svg";
import PointGreyIcon from "@/assets/icons/dashboard/point_grey.svg";

// Types
import { UrgentAction } from "@Dashboard/mock/mockedActions";

// MUI
import { Box, ClickAwayListener, Divider, Link, Stack, Tooltip, Typography } from "@mui/material";
import { useState } from "react";
import { removeUrgentAction } from "@/Dashboard/api/queries";

interface UrgentActionsProps {
	actionsList: UrgentAction[];
}

const UrgentActions = (props: UrgentActionsProps) => {
	const { actionsList } = props;
	const [actions, setActions] = useState<UrgentAction[]>(actionsList || []);
	const [confirmedDelete, setConfirmedDelete] = useState({ actionId: -1, confirmed: false });

	const justifyContentValue = "space-between";
	const columnsTitlesStyles = "!font-['PTSansProNarrowBold'] text-[var(--text-color)]";

	const handleRemoveAction = async (actionId: number) => {
		setConfirmedDelete({ actionId, confirmed: true });
	};

	const handleDelete = async () => {
		const newActions = actions.filter((action) => action.id !== confirmedDelete.actionId);
		setActions(newActions);
		const removed = await removeUrgentAction(confirmedDelete.actionId);
		if (removed !== confirmedDelete.actionId) {
			setActions(actionsList);
		}
	};

	const handleClickAway = () => {
		setConfirmedDelete({ actionId: -1, confirmed: false });
	};

	const deleteActionComponent = (actionId: number) => {
		return confirmedDelete && actionId === confirmedDelete.actionId ? (
			<ClickAwayListener onClickAway={() => handleClickAway()}>
				<Box onClick={() => handleDelete()} className="cursor-pointer">
					<img src={TrashIcon} alt="Remove Icon" className="min-w-fit" />
				</Box>
			</ClickAwayListener>
		) : (
			<Box onClick={() => handleRemoveAction(actionId)} className="cursor-pointer">
				<img src={CloseIcon} alt="Delete Action Icon" className="min-w-fit" />
			</Box>
		);
	};

	return (
		<>
			<Divider />
			<Stack mt={1} mb={0.5} pr={actions.length > 4 ? 2 : 1} direction={"row"} justifyContent={justifyContentValue}>
				<Typography variant="body1" className={columnsTitlesStyles}>
					Actions(s)
				</Typography>
				<Typography variant="body1" className={columnsTitlesStyles}>
					Status
				</Typography>
			</Stack>
			<Divider />
			<ul className="mt-1 h-[10.8rem] overflow-y-auto">
				{actions.map((action, index) => (
					<li key={action.id}>
						<Stack direction={"row"} alignItems={"center"} justifyContent={justifyContentValue}>
							<Stack className="w-[70%]" gap={0.8} direction={"row"} justifyContent={"flex-start"} alignItems={"center"}>
								{!action.finished && <img src={PointGreyIcon} alt="Action Icon" height={"6px"} width={"6px"} />}
								<Typography
									noWrap
									marginLeft={!action.finished ? 0 : 1.6}
									variant="body2"
									className="!font-['PTSansProNarrow'] !text-[var(--text-color)] overflow-hidden text-ellipsis whitespace-nowrap max-w-[248px]"
								>
									{action.actionTitle}
								</Typography>
							</Stack>
							<Stack
								className="w-[30%]"
								py={1}
								pr={2}
								direction={"row"}
								spacing={2.25}
								alignItems={"center"}
								justifyContent={"right"}
							>
								{action.finished ? (
									deleteActionComponent(action.id)
								) : (
									<Link href={action.actionLink} className="min-w-fit">
										<img src={ArrowRightIcon} alt="Link Icon" />
									</Link>
								)}
								<Tooltip title={`${action.daysFromNotification} days ago`} placement="top" arrow>
									<Box className="cursor-pointer">
										<img src={Chronometer} alt="Remove Icon" className="min-w-fit" />
									</Box>
								</Tooltip>
								<img src={action.finished ? FinishedStatusIcon : PendingStatusIcon} alt="Status icon" />
							</Stack>
						</Stack>
						{index !== actions.length - 1 && <Divider className={actions.length > 4 ? "!mr-1.5" : ""} />}
					</li>
				))}
			</ul>
			<Divider
				sx={{
					marginTop: 0.8,
				}}
			/>
		</>
	);
};

export default UrgentActions;
